/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_Row_TotalInputs */

const vi_product_stock_row_total = /** @type {(inputs: Product_Stock_Row_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng`)
};

/**

* @param {Product_Stock_Row_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_row_total = /** @type {((inputs?: Product_Stock_Row_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_Row_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_row_total(inputs)
});